
  // for sold out button
function detectAppleDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    return userAgent.includes("iphone") || platform.includes("iphone") || 
           userAgent.includes("mac") || platform.includes("mac");
}


window.addEventListener("load", (event) => {

  let isAppleDevice
  let cartGeneralNote;
  let cartGeneralNote2;


if(!isAppleDevice) {
  isAppleDevice =  detectAppleDevice();
}



if(isAppleDevice) {
  // mac for showing multiple line of cart note
  if(!cartGeneralNote) cartGeneralNote = document.getElementById("CartGeneralNote"); 
  if (cartGeneralNote) {
    // const lines = cartGeneralNote.textContent.split(/<br\s*\/?>/).map(line => line.trim()).filter(line => line);
    // const wrappedContent = lines.map(line => `<label for="CartNoteDrawer">${line.trim()}</label>`).join("");
    // cartGeneralNote.innerHTML = wrappedContent;
  }

}
    
  if(!cartGeneralNote2) cartGeneralNote2 = document.querySelector('label[for="CartNote"]'); 

  if (cartGeneralNote2) {

const lines2 = cartGeneralNote2.innerHTML
  .replace(/&lt;br\s*\/?&gt;/gi, '<br>')                
  .split(/<br\s*\/?>/i)                                
  .map(line => line.trim())                            
  .filter(line => line);                              

const wrappedContent2 = lines2
  .map(line => `<div>${line}</div>`)
  .join('');

cartGeneralNote2.innerHTML = wrappedContent2;

  }


  if(isAppleDevice) {
    const soldOutLabel = document.querySelector('#sold-out-text');
    if(soldOutLabel) soldOutLabel.classList.add("pt-10");
  }



    // for showing multiple line of cart note
  if(!cartGeneralNote) cartGeneralNote = document.getElementById("CartGeneralNote"); 

  if (cartGeneralNote) {

const lines = cartGeneralNote.innerHTML
  .replace(/&lt;br\s*\/?&gt;/gi, '<br>')                
  .split(/<br\s*\/?>/i)                                
  .map(line => line.trim())                            
  .filter(line => line);                              

const wrappedContent = lines
  .map(line => `<div>${line}</div>`)
  .join('');

cartGeneralNote.innerHTML = wrappedContent;

  }

  if(document.querySelectorAll('.product__thumb-item')[1]) {
      const secondThumbLink = document.querySelectorAll('.product__thumb-item')[1].querySelector('a');
  if(secondThumbLink) {
     secondThumbLink.click();
    }
  }

  // Chatbot 動效開關
  const menuContainer = document.querySelector('.as-floating-menu-container');
  const toggleButton = document.querySelector('.as-menu-toggle-btn');

  if (toggleButton && menuContainer) {
    toggleButton.addEventListener('click', function(event) {
      event.preventDefault();
      menuContainer.classList.toggle('is-open');
    });
  }

});

// 控制 Chatbot 按鈕
window.SmartBotEventLayer = window.SmartBotEventLayer || [];
function SmartBotTag(){SmartBotEventLayer.push(arguments);}
function openChat() {
  SmartBotTag('event', 'open_chat');

  document.querySelector('.as-floating-menu-container').classList.remove('is-open');
}


// =============================================
// 免運進度條 + 運費顯示 - 動態更新
// =============================================

(function() {
  var FREE_SHIPPING_THRESHOLD = 300000; // NT$1,000 in cents
  var SHIPPING_FEE = 170;

  // 免運商品的 variant ID（不計入運費、也不計入免運門檻小計）
  var FREE_SHIPPING_VARIANT_IDS = [
    44539900067906,  // 寶寶彌月試吃
    43091221086274   // 婚約喜餅試吃盒-紙盒版
  ];

  function formatMoney(cents) {
    var amount = Math.ceil(cents / 100);
    return 'NT$' + amount.toLocaleString('zh-TW');
  }

  function updateCartUI(cart) {
    var items = cart.items || [];

    // 分外免運商品 vs 一般商品
    var normalItems = items.filter(function(item) {
      return FREE_SHIPPING_VARIANT_IDS.indexOf(item.variant_id) === -1;
    });
    var hasFreeShippingItem = items.some(function(item) {
      return FREE_SHIPPING_VARIANT_IDS.indexOf(item.variant_id) > -1;
    });

    // 運費小計：只算一般商品
    var normalTotal = normalItems.reduce(function(sum, item) {
      return sum + item.final_line_price;
    }, 0);

    var remaining = FREE_SHIPPING_THRESHOLD - normalTotal;
    var progress = Math.min(Math.round((normalTotal / FREE_SHIPPING_THRESHOLD) * 100), 100);

    // 免運判斷：
    // 1. 只有免運商品 → 免運
    // 2. 一般商品满 NT$3,000 → 免運
    // 3. 其他 → NT$170
    var isComplete = (normalItems.length === 0 && hasFreeShippingItem) || (normalTotal >= FREE_SHIPPING_THRESHOLD);

    // --- 免運進度條 ---
    document.querySelectorAll('.free-shipping-bar').forEach(function(bar) {
      var msgEl = bar.querySelector('.free-shipping-bar__message');
      var fillEl = bar.querySelector('.free-shipping-bar__fill');
      if (!msgEl || !fillEl) return;

      if (normalItems.length === 0 && hasFreeShippingItem) {
        // 全部是免運商品，進度條隐藏
        bar.style.display = 'none';
      } else {
        bar.style.display = '';
        if (isComplete) {
          bar.classList.add('free-shipping-bar--complete');
          msgEl.className = 'free-shipping-bar__message free-shipping-bar__message--success';
          msgEl.innerHTML = '\uD83C\uDF89 已達免運門檻，享受免費配送！';
          fillEl.style.width = '100%';
          fillEl.style.backgroundColor = '#2e7d32';
        } else {
          bar.classList.remove('free-shipping-bar--complete');
          msgEl.className = 'free-shipping-bar__message';
          msgEl.innerHTML = '還差 <strong>' + formatMoney(remaining) + '</strong> 即可免運';
          fillEl.style.width = progress + '%';
          fillEl.style.backgroundColor = '#ff5e5e';
        }
      }
    });

    // --- 運費顯示行 ---
    var drawerVal = document.getElementById('CartDrawerShippingValue');
    var pageVal = document.getElementById('CartPageShippingValue');
    [drawerVal, pageVal].forEach(function(shippingVal) {
      if (!shippingVal) return;
      if (isComplete) {
        shippingVal.innerHTML = '<span class="cart__shipping-original">NT$' + SHIPPING_FEE + '</span> <span class="cart__shipping-free">免費 \uD83C\uDF89</span>';
      } else {
        shippingVal.innerHTML = 'NT$' + SHIPPING_FEE;
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartUI(cart); })
      .catch(function(e) { console.warn('Free shipping bar fetch error:', e); });
  }

  // 頁面載入時立即執行
  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);

  // 監聽 Impulse 主題購物車更新事件
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  // 監聽 [data-subtotal] DOM 變化
  var observer = new MutationObserver(function() {
    fetchCartAndUpdate();
  });

  function attachSubtotalObserver() {
    document.querySelectorAll('[data-subtotal]').forEach(function(el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSubtotalObserver);
  } else {
    attachSubtotalObserver();
  }

})();
